module.exports = __webpack_public_path__ + "img/NightAngel.6b82d03d.jpg";